import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { v4 } from 'uuid'
import { r } from '@utils/styles/functions'
import Tooltip, { ITooltip } from '@components/Tooltip'
import Box, { TBox } from '@components/Box'
import InfoIcon from '@icons/info_v2.inline.svg'

interface ITooltipIconProps extends HTMLAttributes<HTMLDivElement>, TBox {
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  tooltipProps?: Omit<ITooltip, 'elementId'>
}

const STooltipIcon = styled(InfoIcon)`
  display: inline-block;
  cursor: pointer;
  height: ${r(20)};
  width: ${r(20)};
  margin-bottom: ${r(-5)};
`

const IconTooltip: React.FC<ITooltipIconProps> = (props) => {
  const { className, children, icon = InfoIcon, tooltipProps, ...boxProps } = props
  const elementId = v4()

  return (
    <>
      <Box className={className} display="inline-block" {...boxProps}>
        <STooltipIcon as={icon} data-tip data-for={elementId} />
      </Box>
      <Tooltip {...tooltipProps} elementId={elementId} position="top">
        {children}
      </Tooltip>
    </>
  )
}

export default IconTooltip
